<div class="marquee-wrapper" *ngIf="!leaderboardClosed && settings.show_leaderboard && (core.top_prediction_users.length + core.top_simulator_users.length > 0)">
	<header>
		<span>Prediction</span>
		<span>Simulator</span>
		<i class="material-icons" (click)="leaderboardClosed=true">close</i>
	</header>
	<div class="marquee" [style.animation-duration.s]="mover.scrollWidth / 15">

		<div class="mover" #mover [style.animation-duration.s]="mover.scrollWidth / 15">
			<div class="row">
				<div class="user prediction" *ngFor="let u of core.top_prediction_users">
					<span class="info">
						<span class="rank">{{ u.prediction_rank }}</span>
						<i class="material-icons">{{ u.rank.icon }}</i>
						<span class="title"> {{ u.rank.title }}</span>
					</span>
					<small class="stats">
						<span class="name"><img *ngIf="u.avatar" [src]="u.avatar"/>{{ u.username }}</span>
						<span class="percentage">
							<span class="good-text">{{ u.total_right_predictions }}R</span><span class="bad-text">{{ u.total_wrong_predictions }}W</span>:{{ 100 * u.total_right_predictions / ( u.total_right_predictions + u.total_wrong_predictions ) | number:'0.0-2' }}%
						</span>
					</small>
				</div>
			</div>
			<div class="row">
				<div class="user simulator" *ngFor="let u of core.top_simulator_users; let i = index">
					<span class="rank" [ngClass]="'index_' + i">{{ u.bet_rank }}</span>
					<span class="name"><img *ngIf="u.avatar" [src]="u.avatar"/>{{ u.username }}</span>
					<span class="balance">${{ +u.balance + +u.total_unsettled | moneyPipe }}</span>
				</div>
			</div>
		</div>

	</div>
	<footer></footer>
</div>



<ng-container *ngIf="core.is_prediction_active">
	<button *ngIf="profile.is_authenticated" (click)="rankingRulesShown=true" class="prediction_rank"
		[ngClass]="rank.title" [class.calibrated]="user.total_right_predictions + user.total_wrong_predictions >= 100">

		<span class="uncalibrated">
			You need <span class="rank">{{ 100 - user.total_right_predictions - user.total_wrong_predictions }}</span> more <br/> prediction points to get a rank.
		</span>

		<span class="title">
			<span class="material-icons">{{ rank.icon }}</span>
			<span class="text">{{ rank.title }}</span>
			<span class="info"><i class="material-icons">info</i> Info</span>
		</span>

		<span class="number">
			Your Rank, <span class="rank">{{ user.total_right_predictions + user.total_wrong_predictions >= 100 ? user.prediction_rank : '###' }}</span> of {{ total_users }}
		</span>
	</button>
	<button *ngIf="!profile.is_authenticated" (click)="rankingRulesShown=true"
		class="prediction_rank Commoner uncalibrated" (click)="rankingRulesShown=true">

		<span class="uncalibrated">
			You need <span class="rank">100</span> more <br/> prediction points to get a rank.
		</span>

		<span class="title">
			<span class="material-icons">nature_people</span>
			<span class="text">Commoner</span>
			<span class="info"><i class="material-icons">info</i> Info</span>
		</span>

		<span class="number">
			Your Rank, <span class="rank">###</span> of {{ total_users }}
		</span>
	</button>
</ng-container>

<div class="nav-content">
	<div class="profile">

		<button class="login-btn" (click)="login_or_stats_clicked()" [class.glowing]="profile.premium_type == 'HFU'">
			<img [src]="(chat_user && chat_user.avatar) || '/assets/placeholder_avatar_dark.png'" alt=""/>
			<small *ngIf="!chat_user || chat_user.role == 'anon'"> Login </small>
			<small *ngIf=" chat_user && chat_user.role != 'anon'"> My Stats </small>
			<i *ngIf="profile.premium_info" class="premium material-icons">verified</i>
		</button>

		<div class="logo" *ngIf="!chat_user">
			<div>{{ core.top_domain.split('.')[0] | uppercase }}</div>
			<img [src]="core.site_logo" class="site-logo"/>
		</div>

		<aside *ngIf="chat_user">
			<p>
				<span>
					{{ chat_user.username }}
					<small class="role" [ngClass]="chat_user.role">{{ chat_user.role }}</small>
				</span>
				<span class="prediction-stats" *ngIf="profile.is_authenticated">
					<small>
						{{ user.prediction_success_percentage | number:'0.0-2' }}%
						(
						<span class="good-text">{{ user.total_right_predictions }}</span>
						- <span class="bad-text">{{ user.total_wrong_predictions }}</span>
						- <span class="nutral-text">{{ user.total_nulled_predictions }} </span>
						)
					</small>
					<small>
						${{ +user.balance | moneyPipe }}
						(
						<span class="good-text">${{ +user.total_winnings | moneyPipe  }}</span>
						- <span class="bad-text">${{ +user.total_loss | moneyPipe }}</span>
						)
					</small>
				</span>
				<!--small *ngIf="chat_user && !profile.is_authenticated" class="reg-info">
					Register for Free to customize your username and more.
				</small-->
				<small *ngIf="profile.premium_code && !profile.premium_info">Loading Premium...</small>
				<span *ngIf="profile.premium_info" class="premium-package">
					Premium {{ profile.premium_info['credit']['entitlement']['name'] }} Package
					<i *ngIf="profile.premium_sig" class="material-icons">verified_user</i>
					<i *ngIf="profile.premium_sig === null" class="material-icons rotating">sync</i>
					<i *ngIf="profile.premium_sig === false" class="material-icons error">sync_problem</i>
				</span>
				<small *ngIf="profile.premium_info && profile.premium_info['credit']['extra_time']==0" class="premium-expiration">
					<span *ngIf="profile.premium_info['seconds_left'] >= 86400">Expiration Date: {{ profile.premium_info['credit']['expires_at'] | tzdate:'dd-MMM-yyyy (TT)' }}</span>
					<span *ngIf="profile.premium_info['seconds_left'] < 86400" class="warn">Expires {{ profile.premium_info['seconds_left'] | secondsFromNow }}</span>
				</small>
				<small *ngIf="profile.premium_info && profile.premium_info['credit']['extra_time']>0" class="premium-expiration">Transaction Pending Confirmation...</small>
				<button *ngIf="profile.premium_info" class="premium-logout" (click)="premiumLogoutConfirming=true"><i class="material-icons">power_settings_new</i></button>
			</p>
		</aside>

		<div class="activate-button-wrapper" [class.shown]="chat_user" *ngIf="!profile.premium_code">
			<p class="message" *ngIf="premiumError" (click)="premiumError=null" [innerHTML]="premiumError"></p>
			<p class="message" *ngIf="!premiumError && !profile.is_authenticated" style="background: none;">
				<span class="warn-red"><br/></span>
				<span>
					Don't have a Code? Purchase one
					<button class="premium-purchase" (click)="accounting_selection_shown=true">from <b>Here</b>!</button>
					<!--a class="premium-purchase" href="https://account24network.com/" target="_blank">from <b>Here</b>!</a-->
				</span>
			</p>

			<div class="activate-button">
				<i class="material-icons">whatshot</i>
				<input type="tel" maxlength="4" placeholder="" #code1 (paste)="premiumPaste($event)" (keydown)="premiumKeyDown($event, null,  code2)"/><span>-</span>
				<input type="tel" maxlength="4" placeholder="" #code2 (paste)="premiumPaste($event)" (keydown)="premiumKeyDown($event, code1, code3)"/><span>-</span>
				<input type="tel" maxlength="4" placeholder="" #code3 (paste)="premiumPaste($event)" (keydown)="premiumKeyDown($event, code2, code4)"/><span>-</span>
				<input type="tel" maxlength="4" placeholder="" #code4 (paste)="premiumPaste($event)" (keydown)="premiumKeyDown($event, code3, null )"/>
				<button (click)="premiumGo()">Premium</button>
			</div>
		</div>

		<button class="settings prediction_rank" *ngIf="core.is_prediction_active" (click)="rankingRulesShown=true">
			<i class="material-icons">{{ profile.is_authenticated ? rank.icon : 'nature_people' }}</i>
			<span class="title">{{ profile.is_authenticated ? rank.title : 'Commoner' }}</span>
			<span class="info"><i class="material-icons">info</i> Info</span>
		</button>

		<button class="settings" (click)="core.redirectTo('/settings', true)">
			<i class="material-icons">settings</i>
			<span>Device<br/>Settings</span>
		</button>
	</div>
</div>


<div *ngIf="profile.premium_code" class="premium-logout-panel" #premium_logout_panel [class.active]="premiumLogoutConfirming" (click)="close_premium_logout_panel($event, premium_logout_panel)">
	<div class="inner-modal premium-logout">
		<button class="close material-icons" (click)="premiumLogoutConfirming=false;">close</button>
		<span class="title">Are you sure you want to log out from the Premium Site?</span>
		<span class="note" *ngIf="profile.is_authenticated">
			If you only want to log out of your user account (username: {{ chat_user && chat_user.username }}),
			without exiting the premium site, you can do so from inside the chat.<br/>
			Simply click the "My Profile" button, and then choose "Log Out".
		</span>
		<span class="note">If you still want to remove your premium code from this device, Press the button bellow.</span>
		<button class="logout" (click)="profile.premium_logout()">Log Out of Premium</button>
		<small class="note">Make sure you know your premium code in case you want to log back in:<br/><b>{{ profile.premium_info['code'] }}</b></small>
	</div>
</div>

<div class="accounting-selection-panel" #accounting_selection_panel [class.active]="accounting_selection_shown" (click)="close_accounting_selection_panel($event, accounting_selection_panel)">
	<div class="inner-modal accounting-selection">
		<button class="close material-icons" (click)="accounting_selection_shown=false;">close</button>
		<span class="note">
			We are experimenting with a new accounting panel, <a href="https://vip24all.com" target="_blank">vip24all.com</a><br/>
			But you can also choose to use the <a href="https://account24network.com" target="_blank">old one</a> if you are already familiar with it.<br/>
			<b>Premium Codes</b> gotten from both panels will work here, but managing them <i>can only be done in their own respective sites</i>.
		</span>
		<span class="title">Select the accounting option:</span>
		<div class="options">
			<div class="option">
				<a href="https://account24network.com" target="_blank" class="a24n">Use Account24Network</a>
				<small>Recommended for returning users</small>
			</div>
			<div class="option">
				<a href="https://vip24all.com" target="_blank" class="vip24all">Use VIP24ALL</a>
				<small>Recommended for new users</small>
			</div>
		</div>
	</div>
</div>

<div class="rankinfo-panel" #rankinfo_panel [class.active]="rankingRulesShown" (click)="close_rankinfo_panel($event, rankinfo_panel)">
	<div class="inner-modal rankinfo">
		<button class="close material-icons" (click)="rankingRulesShown = false;">close</button>
		<header>
			<h1>Prediction Competition</h1>
			By predicting in our site, you'll be competing with other users and recieve ranks and titles,<br/>
			Each user's title will be computed using <b>3</b> different variables in 3 different steps.
		</header>

		<header class="phase-info">
			The <b>C</b> Variable, <small>Total amount of predictions</small><br/>
			<small>These titles are given to users soley based on their activity, regadless of the outcomes.</small>
		</header>
		<div class="phase">
			<button>
				<i class="material-icons">nature_people</i>
				<span>Commoner</span>
				<small>
					0 &le; C &lt; 10
				</small>
			</button>
			<button>
				<i class="material-icons">child_care</i>
				<span>Newbie</span>
				<small>
					10 &le; C &lt; 25
				</small>
			</button>
		</div>

		<header class="phase-info">
			The <b>V</b> Variable, <small>Algorithm's Rank Value</small><br/>
			<small>
				These titles are given to users based on the value assigned to them by our ranking algorithm.
			</small>
		</header>
		<div class="phase">
			<button>
				<i class="material-icons">school</i>
				<span>Graduate</span>
				<small>
					5 &le; V &lt; 40
				</small>
			</button>
			<button>
				<i class="material-icons">cake</i>
				<span>PieceOfCake</span>
				<small>
					40 &le; V
				</small>
			</button>
		</div>

		<header class="phase-info">
			The <b>R</b> Variable, <small>The Actual rank number</small><br/>
			<small>These are the titles given only to the top 20 users.</small>
		</header>
		<div class="phase">
			<button class="Apprentice">
				<i class="material-icons">face</i>
				<span class="title">Apprentice</span>
				<small>
					20 &le; R &lt; 10
				</small>
			</button>
			<button class="Masterful">
				<span class="icons">
					<i class="material-icons">money</i>
					<i class="material-icons">looks_two</i>
					<i class="material-icons">looks_3</i>
				</span>
				<span class="title">Masterful</span>
				<small>
					10 &le; R &le; 2
				</small>
			</button>
			<button class="Oracle">
				<i class="material-icons">visibility</i>
				<span class="title">Oracle</span>
				<small>
					Number One
				</small>
			</button>
		</div>

		<footer>
			<p>
				You can view the top 20 users, by using the "Show Rankings" Button on the top corner of chat.<br/>
				Also, each user's stats can be seen in Chat, via a "rank" link next to their name.
			</p>
		</footer>
	</div>
</div>
